import { render } from "./FeaturedAlbums.vue?vue&type=template&id=b9233f58"
import script from "./FeaturedAlbums.vue?vue&type=script&lang=js"
export * from "./FeaturedAlbums.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__